//import { version } from '../../../../../package.json';
//import { Component, EventEmitter, Input, Output, VERSION } from '@angular/core';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'nav-menu',
    templateUrl: './navmenu.component.html',
    styleUrls: ['./navmenu.component.css'],
    standalone: false
})
export class NavMenuComponent {
    @Input() isExpanded: boolean = true;
    @Input() isLoggedIn: boolean = false;
    @Output() navigationToggled: EventEmitter<boolean> = new EventEmitter<boolean>();

    //public appVersion: string = VERSION.full;
    public appVersion: string = environment.packageJson.version;

    constructor(private router: Router, public authService: AuthService) {
        var routePath = this.router.url;
        //console.log("version", this.appVersion, environment, environment.packageJson.version);
    }

    public isLinkActive(name: string): boolean {
        return (this.router.url == name || this.router.url.startsWith(name));
    }

    public login() {
        //this.authService.signIn();
        this.router.navigate(['/home']);
        //this.authService.loginPopup();
    }

    public logout() {
        //this.authService.signOut();
        this.authService.logout();
    }
}
